import React, { useState, createContext } from "react";

type ValueGraphContext = {
  startDate: string;
  endDate: string;
  setDates: (data: Record<string, any>) => void;
  isRestarted: boolean;
  toggleRestartedStats: () => void;
};

export const GrapghContext = createContext<ValueGraphContext | undefined>(
  undefined
);

const GraphProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isRestarted, setIsRestarted] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const setDates = (data: Record<string, any>) => {
    setStartDate(data.startDate);
    setEndDate(data.endDate);
  };

  const toggleRestartedStats = () => {
    setIsRestarted(!isRestarted);
  };

  return (
    <GrapghContext.Provider
      value={{
        startDate,
        endDate,
        setDates,
        isRestarted,
        toggleRestartedStats,
      }}
    >
      {children}
    </GrapghContext.Provider>
  );
};

export default GraphProvider;
